let env

if (typeof window !== 'undefined') {
  env = {
    ...window.__APP_STATE__.env,
  }
} else {
  env = {
    AI_API_BASE_URL: process.env.AI_API_BASE_URL,
    APP_VERSION: process.env.APP_VERSION,
    AI_API_BASE_URL: process.env.AI_API_BASE_URL,
    API_URL: process.env.API_URL,
    APP_ENV: process.env.APP_ENV,
    GOOGLE_API_KEY: process.env.GOOGLE_API_KEY,
    RH_URL: process.env.RH_URL,
    VENDOR_URL: process.env.VENDOR_URL,
    CATERING_URL: process.env.CATERING_URL,
    SENTRY_DSN: process.env.SENTRY_DSN,
    POSTHOG_TOKEN: process.env.POSTHOG_TOKEN,
    POSTHOG_HOST: process.env.POSTHOG_HOST,
    BRAINTREE_ENVIRONMENT: process.env.BRAINTREE_ENVIRONMENT,
    BRAINTREE_MERCHANT_ID: process.env.BRAINTREE_MERCHANT_ID,
  }
}

export default env
